import type { CityConfig } from "../city-template/types";

export const virginiaBeachConfig: CityConfig = {
  city: "Virginia Beach",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "virginia-beach",
  route: "/cities/virginia-beach",
  title: "Emergency Passport Virginia Beach, VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Virginia Beach, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Navy, Marine, Coast Guard families and Hampton Roads travelers. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Virginia Beach, VA",
  heroSubtitle: "Passport expired before your deployment or beach vacation? Need an emergency passport fast? We help Virginia Beach and Hampton Roads travelers — including military families stationed at NAS Oceana, JEB Little Creek, and Fort Story — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20photograph%20of%20Virginia%20Beach%20oceanfront%20at%20sunrise%20with%20the%20iconic%20boardwalk%2C%20golden%20sand%20stretching%20along%20the%20Atlantic%20Ocean%2C%20gentle%20waves%20lapping%20the%20shore%2C%20warm%20orange%20and%20pink%20sunrise%20colors%20reflecting%20on%20the%20water%2C%20beachfront%20hotels%20and%20resort%20skyline%20in%20the%20background%2C%20lush%20green%20coastal%20vegetation%2C%20clean%20vibrant%20sky%20with%20soft%20clouds%2C%20professional%20coastal%20photography%20with%20vivid%20warm%20colors%20and%20sharp%20detail%2C%20no%20text%20or%20signs%20visible&width=1800&height=700&seq=virginia-beach-hero-001&orientation=landscape",
  heroImageAlt: "Virginia Beach oceanfront at sunrise with the boardwalk and Atlantic Ocean shoreline",
  geoPosition: "36.8529;-75.9780",
  geoPlacename: "Virginia Beach, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 200 miles from Virginia Beach via I-64 and I-95",
  },
  nearbyCitiesZips: [
    { name: "Virginia Beach", zips: "23450–23479" },
    { name: "Norfolk", zips: "23501–23523" },
    { name: "Chesapeake", zips: "23320–23328" },
    { name: "Portsmouth", zips: "23701–23709" },
    { name: "Suffolk", zips: "23432–23439" },
    { name: "Hampton", zips: "23661–23669" },
    { name: "Newport News", zips: "23601–23609" },
    { name: "Williamsburg", zips: "23185, 23188" },
    { name: "Richmond", zips: "23219–23242" },
    { name: "Salem", zips: "23456, 23457" },
    { name: "Princess Anne", zips: "23456, 23457" },
    { name: "Great Bridge", zips: "23320, 23322" },
    { name: "Greenbrier", zips: "23320" },
    { name: "Kempsville", zips: "23464" },
    { name: "Lynnhaven", zips: "23452, 23455" },
    { name: "Pungo", zips: "23456, 23457" },
    { name: "Sandbridge", zips: "23456" },
    { name: "Bayside", zips: "23455, 23462" },
    { name: "Shore Drive", zips: "23455" },
    { name: "Red Mill", zips: "23457" },
    { name: "Dam Neck", zips: "23454" },
    { name: "Oceana", zips: "23454" },
    { name: "Fort Story", zips: "23459" },
    { name: "Larkspur", zips: "23462" },
    { name: "West Neck", zips: "23456" },
    { name: "First Colonial", zips: "23454" },
    { name: "Hilltop", zips: "23451" },
    { name: "Alanton", zips: "23454" },
    { name: "Thoroughgood", zips: "23455" },
    { name: "Bayside", zips: "23455" },
    { name: "Charlottesville", zips: "22901–22911" },
    { name: "Roanoke", zips: "24001–24020" },
    { name: "Fredericksburg", zips: "22401–22408" },
    { name: "Arlington", zips: "22201–22217" },
    { name: "Alexandria", zips: "22301–22315" },
    { name: "McLean", zips: "22101, 22102" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Hampton Roads departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Hampton Roads Hub", desc: "Serving Virginia Beach, Norfolk, Chesapeake, and all of Hampton Roads" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Virginia Beach remotely via secure courier. We do not have a walk-in office in Virginia Beach — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Hampton Roads travelers.",
  fpcOfficeDistance: "Serving all of Virginia Beach and the Hampton Roads region including Norfolk, Chesapeake, Portsmouth, Suffolk, Hampton, and Newport News",
  serviceAreaIntro: "From the Oceanfront boardwalk to Sandbridge, from Kempsville to Great Bridge, from NAS Oceana to Fort Story — Fast Passport Center serves the entire Hampton Roads region. We regularly help Navy, Marine, and Coast Guard families, plus beach vacationers and business travelers, get their passports fast.",
  nearbyCitiesIntro: "We serve all Virginia Beach neighborhoods and the surrounding Hampton Roads region including Norfolk, Chesapeake, Portsmouth, Suffolk, Hampton, Newport News, Williamsburg, and extending to Richmond, Charlottesville, and Fredericksburg. If you are anywhere in the Hampton Roads metropolitan area, we have you covered.",
  howItWorksIntro: "Most Virginia Beach travelers complete everything online and ship documents overnight. No need to drive to Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Virginia Beach travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Virginia Beach and Hampton Roads travelers trust us when their deployment, vacation, or business trip is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Virginia Beach? Here are the most common ones we hear from Hampton Roads travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Virginia Beach international flights and deployments.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "Virginia Beach, VA",
      rating: 5,
      text: "My husband is Navy and got short-notice orders to Japan. Fast Passport Center had our family's passports ready in 3 days. They understood the military urgency and handled everything perfectly.",
      service: "Emergency Passport",
    },
    {
      name: "David K.",
      location: "Norfolk, VA",
      rating: 5,
      text: "Booked a Caribbean cruise and realized my passport expired 2 weeks before sailing. Fast Passport Center saved our vacation with a 4-day renewal. I shipped from the Lynnhaven UPS and never left Hampton Roads.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer L.",
      location: "Chesapeake, VA",
      rating: 5,
      text: "First passports for my twins before our family trip to Europe. Fast Passport Center walked us through the parental consent process and had everything ready in 5 days. Couldn't have done it without them.",
      service: "Child Passport",
    },
    {
      name: "Marcus T.",
      location: "Virginia Beach, VA",
      rating: 5,
      text: "Lost my passport the day before a business trip to London. Fast Passport Center had a replacement in my hands in 30 hours. These guys are absolute lifesavers for anyone in Hampton Roads.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "virginia-beach-1",
      name: "Virginia Beach Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1355 Laskin Rd",
      city: "Virginia Beach",
      state: "VA",
      zip: "23451",
      phone: "(757) 425-2191",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Virginia Beach, near Hilltop",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Virginia Beach facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "virginia-beach-2",
      name: "Princess Anne Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1250 Princess Anne Rd",
      city: "Virginia Beach",
      state: "VA",
      zip: "23457",
      phone: "(757) 721-2251",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southern Virginia Beach, Princess Anne area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Virginia Beach, Pungo, and Sandbridge areas. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "virginia-beach-3",
      name: "Norfolk Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "555 E Main St",
      city: "Norfolk",
      state: "VA",
      zip: "23510",
      phone: "(757) 625-3161",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Norfolk, approximately 15 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Norfolk facility serving downtown and Naval Station area. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "virginia-beach-4",
      name: "Chesapeake Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1400 Plaza Dr",
      city: "Chesapeake",
      state: "VA",
      zip: "23320",
      phone: "(757) 547-3461",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Western Virginia Beach, Chesapeake city center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chesapeake and western Virginia Beach including Greenbrier and Great Bridge. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "virginia-beach-5",
      name: "Portsmouth Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 Crawford St",
      city: "Portsmouth",
      state: "VA",
      zip: "23704",
      phone: "(757) 397-0521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Portsmouth, approximately 20 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Portsmouth and western Hampton Roads. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "virginia-beach-6",
      name: "Hampton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Eaton St",
      city: "Hampton",
      state: "VA",
      zip: "23669",
      phone: "(757) 722-2491",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hampton, approximately 35 miles north via I-64",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hampton, Langley AFB, and northern Peninsula area. Call for appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5 hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Virginia Beach photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hampton Roads acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Virginia Beach applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hampton Roads families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Virginia Beach travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Virginia Beach." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Virginia Beach address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Virginia Beach before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Virginia Beach for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3.5 hour drive to Washington, DC." },
    { q: "How fast can I renew my passport in Virginia Beach?", a: "Fast Passport Center offers fast passport renewal in Virginia Beach in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Virginia Beach?", a: "The nearest regional passport agency to Virginia Beach is the Washington Passport Agency, approximately 200 miles away via I-64 and I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Virginia Beach without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Virginia Beach?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency — approximately 3.5 hours from Virginia Beach — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Hampton Roads residents." },
    { q: "Can I expedite a child passport in Virginia Beach?", a: "Yes. Fast Passport Center expedites child passports in Virginia Beach for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Hampton Roads families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Virginia Beach with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Virginia Beach?", a: "With Fast Passport Center's emergency courier service, Virginia Beach travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Virginia Beach?", a: "Popular options include the Virginia Beach Main Post Office (23451), Princess Anne Post Office (23457), Norfolk Main Post Office (23510), Chesapeake Main Post Office (23320), Portsmouth Main Post Office (23704), and Hampton Main Post Office (23669). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Virginia Beach?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 3.5 hour drive to DC." },
    { q: "What if I live in a smaller Hampton Roads town?", a: "We serve the entire Hampton Roads region including Norfolk, Chesapeake, Portsmouth, Suffolk, Hampton, Newport News, and Williamsburg. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed. We also serve Richmond, Charlottesville, and Fredericksburg." },
    { q: "How much does expedited passport service cost in Virginia Beach?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help military personnel in Virginia Beach?", a: "Absolutely. We regularly assist Navy, Marine, and Coast Guard personnel stationed at NAS Oceana, JEB Little Creek, Fort Story, and Naval Station Norfolk. We understand military orders and deployment urgency, and can process passports as fast as 24–48 hours for PCS orders and emergency leave." },
    { q: "Do you help with passport photos in Virginia Beach?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and Walmart locations in Virginia Beach, Norfolk, and Chesapeake offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Virginia Beach?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Virginia Beach?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Hampton Roads families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Virginia Beach", address: "2113 General Booth Blvd, Virginia Beach, VA 23454", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Virginia Beach", address: "1105 Independence Blvd, Virginia Beach, VA 23455", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Virginia Beach", address: "2020 Lynnhaven Pkwy, Virginia Beach, VA 23456", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Virginia Beach", address: "4554 Virginia Beach Blvd, Virginia Beach, VA 23462", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Norfolk", address: "850 W 21st St, Norfolk, VA 23517", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Chesapeake", address: "2001 S Military Hwy, Chesapeake, VA 23320", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Chesapeake", address: "2448 Chesapeake Square Ring Rd, Chesapeake, VA 23321", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Norfolk", address: "5900 E Virginia Beach Blvd, Norfolk, VA 23502", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Virginia Beach",
      address: "1712 Princess Anne Rd, Virginia Beach, VA 23456",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Norfolk",
      address: "850 Widgeon Rd, Norfolk, VA 23513",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Chesapeake",
      address: "803 Corridor Ct, Chesapeake, VA 23320",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Chesapeake and western Virginia Beach residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Hampton",
      address: "8109 Roanoke Ave, Hampton, VA 23661",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Hampton, Newport News, and Peninsula area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "15 miles north of Virginia Beach, in Norfolk",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "The primary airport for Hampton Roads. Direct flights to major domestic destinations and international connections. Serves Norfolk, Virginia Beach, and the entire Hampton Roads region.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: true,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "100 miles northwest of Virginia Beach",
      address: "1 Richard E Byrd Terminal Dr, Richmond, VA 23250",
      note: "Alternative airport for domestic flights. Accessible via I-64.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
    {
      code: "DCA",
      name: "Reagan National Airport",
      distance: "200 miles north of Virginia Beach",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Major international hub for long-haul flights to Europe and Asia. Accessible via I-64 and I-95.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
  ],
};